import { graphql } from '../../../gql';

export const CREATE_VOUCH_MUTATION = graphql(`
  mutation createVouch($recipientUserId: ID!, $credits: Int!) {
    createVouch(recipientUserId: $recipientUserId, credits: $credits) {
      vouchId boost windowEndsAt
    }
  }
`);
